// EditPriceModal.jsx (props: show,onClose,scope,serial,batch,itemId,currentPrice)
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
 
import { toast } from 'react-toastify';
import apiService from '../../services/apiServices';

const EditPriceModal = ({ show, onClose, scope, itemId, variantId, serial, batch, currentPrice }) => {
  const [newPrice, setNewPrice] = useState(currentPrice || 0);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!reason) return toast.error('Reason is required');
    setLoading(true);
    try {
      if (scope === 'serial') {
        await apiService.patch(`/stock/serial/${serial}/price`, { newSellingPrice: newPrice, reason, });
      } else if (scope === 'batch') {
        await apiService.patch(`/stock/batch/${batch}/price`, { item_id: itemId, newSellingPrice: newPrice, reason, });
      } else {
        await apiService.patch(`/items/${itemId}/price`, { variant_id: variantId, newSellingPrice: newPrice, reason, });
      }
      toast.success('Price updated');
      onClose(true); // signal refresh
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally { setLoading(false); }
  };

  return (
    <Modal show={show} onHide={() => onClose(false)}>
      <Modal.Header closeButton><Modal.Title>Edit Price</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Current Price</Form.Label>
          <Form.Control readOnly value={currentPrice} />
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Label>New Price</Form.Label>
          <Form.Control type="number" value={newPrice} onChange={e => setNewPrice(Number(e.target.value))} />
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Label>Reason</Form.Label>
          <Form.Control as="textarea" rows={3} value={reason} onChange={e => setReason(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="primary" onClick={submit} disabled={loading}>{loading? 'Saving...':'Save'}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPriceModal;
